import * as MapColorGeneratorActions from './map-color-generator.actions'

export { MapColorGeneratorActions }